import style from '../../assets/style/header.scss'
import logoImg from '../../assets/images/logo.png'
import logo2 from '../../assets/images/icon_logo.png'
import React, {useState, useEffect} from 'react';

const Header = () => {
        const menuList = [
            {
                title: '首页'
            },
            {
                title: '学前联萌AI平台'
            },
            {
                title: '业务生态圈'
            },
            {
                title: '关于我们'
            }
        ]
        const [currentIndex, setCurrentIndex] = useState(0)
        const [showMenuPopup, setShowMenuPopup] = useState(false)
        const [isScrolled, setIsScrolled] = useState(false);
        // 手动实现节流函数
        const throttle = (func, delay) => {
            let lastCall = 0;
            return (...args) => {
                const now = new Date().getTime();
                if (now - lastCall < delay) return;
                lastCall = now;
                func(...args);
            };
        };
        useEffect(() => {
            const handleScroll = throttle(() => {
                if (window.scrollY > 100 && window.innerWidth > 1000) {
                    setIsScrolled(true);
                } else {
                    setIsScrolled(false);
                }
            }, 100); // 每 100ms 触发一次

            window.addEventListener('scroll', handleScroll);
            return () => {
                window.removeEventListener('scroll', handleScroll);
            };
        }, []);

        const changeTab = (tab) => {
            if (showMenuPopup) {
                setShowMenuPopup(false)
            }
            switch (tab.title) {
                case '学前联萌AI平台':
                case '业务生态圈':
                    window.scrollTo({
                        top: document.documentElement.scrollHeight,
                        behavior: 'smooth'
                    });
                    break;
                case '关于我们':
                    window.open('https://mp.weixin.qq.com/s/Gu8cgZYGIZClXSoxwrg58w', "_blank")
                    break;
            }
        };

        const navigatorSite = (key) => {
            let aiUrl = '', siteUrl = 'https://job-express.123xqlm.cn/';
            switch (process.env.REACT_APP_TERMINAL) {
                case 'development':
                case 'test':
                    aiUrl = 'http://tenant.test.123xqlm.cn/login'
                    break;
                case 'production':
                    aiUrl = 'https://tenant.sit.123xqlm.cn/login'
                    break;
            }
            if (key === 'ai') {
                window.open(aiUrl, '_black')
            }else{
                window.open(siteUrl, '_black')
            }
        }

        return (
            <div
                className={`header animate__delay-1s animate__animated animate__slideInDown ${isScrolled ? 'header-sticky' : ''}`}>
                <div className='header-inner'>
                    <div className="logo-main">
                        <img className='logo-white' src={logoImg}></img>
                        <img className='logo-color' src={logo2}></img>
                    </div>

                    <div className="header-middle">
                        <ul className="main-nav">
                            {menuList.map((item, index) =>
                                (<li className="animation-itemwrap" key={index} onClick={() => changeTab(item)}>
                                    <div className={`animation-itemparent ${currentIndex === index ? 'current' : ''}`}>
                                        <div>
                                            <div className="animation-item ">{item.title}</div>
                                            <div className="animation-item current">{item.title}</div>
                                        </div>
                                    </div>
                                </li>)
                            )}
                        </ul>
                    </div>

                    <div className="header-right">
                        <div className={`icon-menu ${showMenuPopup ? 'hide' : 'open'}`}>
                            <div className='icon iconfont icon-icon-cd' onClick={() => setShowMenuPopup(true)}></div>
                        </div>
                        <div className={`icon-close ${showMenuPopup ? 'open' : 'hide'}`}>
                            <div className='icon iconfont icon-icon_close' onClick={() => setShowMenuPopup(false)}></div>
                        </div>
                        <div className="btn-link animation-itemwrap" onClick={() => navigatorSite('ai')}>
                            <div className="animation-itemparent">
                                <div>
                                    <div className="animation-item">幼儿园人工智能管理平台</div>
                                    <div className="animation-item current">幼儿园人工智能管理平台</div>
                                </div>
                            </div>
                        </div>
                        <div className="btn-link animation-itemwrap" onClick={() => navigatorSite('recruitment')}>
                            <div className="animation-itemparent">
                                <div>
                                    <div className="animation-item ">招聘系统</div>
                                    <div className="animation-item current">招聘系统</div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={`menu-popup ${showMenuPopup ? 'open' : ''}`}>
                    <ul>
                        {menuList.map((item, index) =>
                            <li key={index} onClick={() => changeTab(item)}>{item.title}</li>
                        )}
                    </ul>
                    <ul>
                        <li>学前联萌AI平台</li>
                        <li>招聘系统</li>
                    </ul>
                </div>
            </div>

        );
    }
;

export default Header;
